import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/landing.module.css";

const PricingSection = ({ id }) => {
  return (
    <section className={styles.pricingSection} id={id}>
      <h2>Pricing</h2>

      <p className={styles.pricingIntro}>
        Two options tailored to your needs to optimize your learning
      </p>
      
      <div className={styles.pricingContainer}>
        <div className={`${styles.pricingCard} ${styles.free}`}>
          <h3>Free</h3>
          <p className={styles.price}>€0</p>
          <p className={styles.period}>forever</p>
          
          <ul className={styles.features}>
            <li>Up to 3 revision subjects</li>
            <li>Spaced repetition algorithm</li>
            <li>Basic algorithm customization</li>
            <li>Basic progress tracking</li>
            
          </ul>
          
          <Link to="/register" className={`${styles.pricingButton} ${styles.freeButton}`}>
            Start for free
          </Link>
        </div>
        
        <div className={`${styles.pricingCard} ${styles.premium}`}>
          <div className={styles.popularTag}>Popular</div>
          <h3>Premium</h3>
          <p className={styles.price}>€5.00</p>
          <p className={styles.period}>per month</p>
          
          <ul className={styles.features}>
            <li>Unlimited revision subjects</li>
            <li>Customizable advanced algorithm</li>
            <li>Detailed progress statistics</li>
            <li>Google Calendar integration</li>
            <li>Email notifications</li>
            <li>Priority support</li>
          </ul>
          
          <Link 
            to="/register?subscribe=premium" 
            className={`${styles.pricingButton} ${styles.premiumButton}`}
          >
            Try Premium
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PricingSection; 